<link href="https://fonts.googleapis.com/icon?family=Material+Icons"
  rel="stylesheet">
<script type="text/javascript" src="https://www.gstatic.com/charts/loader.js"></script>

<mat-card>
    <mat-card-header>
      <mat-card-title>
        <i class="material-icons" id="firmware-ver">camera</i>
        
        <strong> Cameras</strong>
      </mat-card-title>

    </mat-card-header>
    <br>
    <mat-card-content>
        
        <div id="cameras" class="cameras"></div>     
        
    </mat-card-content>
</mat-card>
  